export const gmbAddonsListPath = "/getmybib/";
export const gmbAddonDetailPath = "/getmybib/:bookingId";

export const gmbAddonsListUrl = (page?: number): string =>
  page ? `${gmbAddonsListPath}?page=${page}` : gmbAddonsListPath;

export const gmbAddonDetailUrl = (bookingId: string, orderId?: string): string => {
  const base = `/getmybib/${encodeURIComponent(bookingId)}`;

  return orderId ? `${base}?order_id=${encodeURIComponent(orderId)}` : base;
};
